import qs from 'query-string';
import useService from './axios-config';
import { PNQ, SESSION_STORAGE } from '../constants';
import { findParamFromUrl, getFromSessionStorage } from 'common/utils/app.utils';
import { MODULE_ID, SELECTED_PARTY_ACCOUNT } from 'home/common/constants/constants';

const { _get, _post, _patch, isApiSuccess } = useService();

const access_token = localStorage && localStorage.getItem('accessToken');

const pnq_token = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN);

const user_type = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE);

const createLeadAsync = (payload) => {
  const config = {
    headers: {
      accessToken: access_token
    }
  };

  return _post(PNQ.CREATE_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getLeadAsync = (token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _get(PNQ.GET_LEAD, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const validateLeadAsync = (payload) => {
  const config = {
    headers: {
      accessToken: access_token
    }
  };

  return _post(PNQ.VALIDATE_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getLsiDetails = (lsi) => {
  const partyId = getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT) ?? findParamFromUrl('partyId', false);

  const config = {
    headers: {
      // accessToken: localStorage && localStorage.getItem('accessToken')
    }
  };

  const queryParams = {
    lsi,
    partyId
  };

  return _get(`${PNQ.GET_LSI_DETAILS}?${qs.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getPricingAsync = (product, service, token, media) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  const queryParams = {
    product,
    service,
    media
  };

  return _get(`${PNQ.GET_PRICING}?${qs.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getCpeAsync = (currentBw, orderType, source, product, segment, token, hardwareType = null) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  const queryParams = {
    orderType,
    source,
    product,
    segment,
    hardwareType
  };

  return _get(`${PNQ.GET_CPE}?${qs.stringify(queryParams)}&bandwidth=${currentBw?.key?.split(' ')?.join('+')}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const checkFeasibilityAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _post(PNQ.CHECK_FEASIBILITY, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const checkFeasibilityShiftingAsync = (payload, params, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
      // pnqId: params.pnqId
    }
  };

  return _post(`${PNQ.CHECK_FOR_ID}?${qs.stringify(params)}`, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const updateLeadAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _post(PNQ.UPDATE_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cancelLeadAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token,
      userType: user_type
    }
  };

  return _post(PNQ.CANCEL_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const needAssistanceAsync = (payload, token, userType) => {
  const config = {
    headers: {
      Authorization: token || pnq_token,
      userType: userType || user_type
    }
  };

  return _post(PNQ.NEED_ASSISTANCE, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const submitLeadAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token,
      userType: user_type
    }
  };

  return _post(PNQ.SUBMIT_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getLeadTagsAsync = (token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _get(PNQ.LEAD_TAGS, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getDoaLifeCycleAsync = (doaId) => {
  const queryParams = {
    doaId
  };

  return _get(`${PNQ.DOA_LIFE_CYCLE}?${qs.stringify(queryParams)}`)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const kamSubmitLeadAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _post(PNQ.KAM_SUBMIT_LEAD, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const doaSubmitClarityAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  return _post(PNQ.DOA_SUBMIT_CLARITY, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export {
  createLeadAsync,
  getLeadAsync,
  validateLeadAsync,
  getPricingAsync,
  getCpeAsync,
  checkFeasibilityAsync,
  checkFeasibilityShiftingAsync,
  updateLeadAsync,
  cancelLeadAsync,
  needAssistanceAsync,
  submitLeadAsync,
  getLeadTagsAsync,
  kamSubmitLeadAsync,
  doaSubmitClarityAsync,
  getDoaLifeCycleAsync,
  getLsiDetails
};
